// SERVIS · motion leaf — counters + reveal

import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { usePrefersReducedMotion } from "@/lib/animation/prefers-reduced-motion";
import { DUR } from "@/features/landing/motion/tokens";
import { COPY } from "@/features/landing/content/landing-copy";

export function useServisMotion(scope: React.RefObject<HTMLElement | null>) {
  const reduced = usePrefersReducedMotion();

  useGSAP(
    () => {
      const head = scope.current?.querySelector<HTMLElement>(".servis__head");
      const counters = scope.current?.querySelectorAll<HTMLElement>(".servis__counter");

      if (reduced) {
        gsap.set([head, ...(counters ?? [])], { clearProps: "all" });
        return;
      }

      if (head) {
        gsap.fromTo(head, { autoAlpha: 0, y: 32 }, {
          autoAlpha: 1, y: 0, duration: DUR.slow, ease: "power3.out",
          scrollTrigger: { trigger: head, start: "top 80%", toggleActions: "play none none reset" },
        });
      }

      // Animated counters
      if (counters && counters.length) {
        counters.forEach((counter, i) => {
          gsap.fromTo(counter, { autoAlpha: 0, y: 30 }, {
            autoAlpha: 1, y: 0, duration: DUR.normal, ease: "power3.out",
            delay: i * 0.1,
            scrollTrigger: { trigger: counter, start: "top 88%", toggleActions: "play none none reset" },
          });

          const num = counter.querySelector<HTMLElement>(".servis__num");
          if (num) {
            const target = COPY.servis.counters[i].num;
            const obj = { val: 0 };
            gsap.to(obj, {
              val: target,
              duration: DUR.slow * 1.5,
              ease: "power2.out",
              delay: 0.2 + i * 0.1,
              scrollTrigger: { trigger: counter, start: "top 85%", toggleActions: "play none none reset" },
              onUpdate: () => {
                const formatted = obj.val >= 1000
                  ? obj.val.toLocaleString("tr-TR")
                  : Math.round(obj.val).toString();
                num.firstChild!.textContent = formatted;
              },
            });
          }
        });
      }
    },
    { scope, dependencies: [reduced] }
  );
}